define('Officeretail.ei1.Main', [
    'Office_retail.ei1.Main.View'
], function (OfficeretailView) {
    'use strict';

    return {
        mountToApp: function (container) {
            const Layout = container.getComponent('Layout');
            if (Layout) {
                Layout.addChildView('Officeretail.ei1.Main', function () {

                    return new OfficeretailView({ container: container, });
                });
            }

        }

    };
});
